import User from '@/api/user'

const onItemSuccess = (commit, item) => {
  commit('changeLoading', { isLoading: false })
  commit('replaceItem', { item })
  return item
}

const onError = (commit, error) => {
  commit('userError', { error: error.response ? error.response.data.error : error.message })
  commit('changeLoading', { isLoading: false })
  return Promise.reject(error)
}

const adminAction = action => ({ commit }, { id, reason }) => {
  commit('changeLoading', { isLoading: true })
  return action({ id, reason })
    .then(({ data }) => onItemSuccess(commit, data))
    .catch(error => onError(commit, error))
}

export default {
  fetchPerPage: ({ commit, getters, rootState }, filter) => {
    commit('changeLoading', { isLoading: true })
    return User.fetchAll(filter)
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: filter
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => onError(commit, error))
  },
  fetch: ({ commit }, { id }) => {
    commit('changeLoading', { isLoading: true })
    return User.fetch({ id })
      .then(({ data }) => onItemSuccess(commit, data))
      .catch(error => onError(commit, error))
  },
  lock: adminAction(User.lock),
  unlock: adminAction(User.unlock),
  risk: adminAction(User.risk),
  unrisk: adminAction(User.unrisk),
  save: ({ commit }, { id, data }) => {
    commit('changeLoading', { isLoading: true })
    return User.save({ id, data })
      .then(({ data }) => onItemSuccess(commit, data))
      .catch(error => onError(commit, error))
  },
  create: ({ commit }, data) => {
    commit('changeLoading', { isLoading: true })
    return User.create(data)
      .then(({ data }) => onItemSuccess(commit, data))
      .catch(error => onError(commit, error))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/users/actions.js